
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { eventDELETE, eventPATCH, myEventsGET } from '../EventApi';
import { participantsPATCH } from '../ParticipantsApi';
import EventForm from './EventForm';
const MyEvents = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [localEventData, setLocalEventData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);


const getPHNow = () => {
  const now = new Date();

  const date = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Manila',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now).replace(/\//g, '-');

  const time = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Manila',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(now);

  return { date, time };
};

  const fetchEvents = async () => {
    try {
      const data = await myEventsGET();
      const parsed = data.map(ev => {
        const [start_time, end_time] = ev.time_range.split('-');
        return { ...ev, start_time, end_time };
      });
      setEvents(parsed);
    } catch (err) {
      console.error('❌ Failed to fetch events:', err.message);
    }
  };

  // run once on mount
  useEffect(() => {
    fetchEvents();
  }, []);



  // View modal
  const handleView = (event) => {
    setSelectedEvent(event);
    setLocalEventData({ ...event });
    setShowViewModal(true);
  };

 const handleLocalChange = (e) => {
  const { name, value } = e.target;

  setLocalEventData(prev => ({ ...prev, [name]: value }));

  
};


 const nowPH = new Date();


const todayDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(nowPH).replace(/\//g, '-');

const currentTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Manila',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).format(nowPH);



const handleTimeChange = (field, value) => {
  setLocalEventData((prev) => {
    const updated = { ...prev, [field]: value };

    const isToday = updated.event_date === todayDate;

    if (field === 'start_time') {
      if (isToday && value < currentTime) {
        alert('Start time cannot be earlier than current time');
        return prev;
      }

      if (updated.end_time && value >= updated.end_time) {
        alert('Start time must be earlier than end time');
        return prev;
      }
    }

    if (field === 'end_time') {
      if (updated.start_time && value <= updated.start_time) {
        alert('End time must be later than start time');
        return prev;
      }
    }

    return updated;
  });
};


const handleSaveChanges = async () => {
  const now = new Date();
  const eventDate = new Date(localEventData.event_date);

  const [startH, startM] = localEventData.start_time.split(":").map(Number);
  const [endH, endM] = localEventData.end_time.split(":").map(Number);

  const startDateTime = new Date(eventDate);
  startDateTime.setHours(startH, startM, 0, 0);

  const endDateTime = new Date(eventDate);
  endDateTime.setHours(endH, endM, 0, 0);

  if (Number(localEventData.max_participants) <= 0) {
    alert("Max participants must be greater than zero");
    return;
  }

  if (!localEventData.start_time || !localEventData.end_time) {
    alert("Start and end time are required");
    return;
  }

  if (startDateTime < now) {
    alert("Start time cannot be in the past");
    return;
  }

  if (endDateTime <= startDateTime) {
    alert("End time must be later than start time");
    return;
  }

  try {
    const payload = {
      id: localEventData.id,
      event_name: localEventData.event_name,
      event_date: localEventData.event_date,
      time_range: `${localEventData.start_time}-${localEventData.end_time}`,
      description: localEventData.description,
      venue: localEventData.venue,
      max_participants: Number(localEventData.max_participants),
      permission: localEventData.permission,
      address: localEventData.address,
    };

    const updatedEvent = await eventPATCH(payload);
    const [updatedStart, updatedEnd] = updatedEvent.time_range.split("-");

    setEvents(prev =>
      prev.map(ev =>
        ev.id === updatedEvent.id
          ? { ...updatedEvent, start_time: updatedStart, end_time: updatedEnd }
          : ev
      )
    );

    fetchEvents();
    setShowViewModal(false);

  } catch (err) {
    const serverMessage = err.response?.data?.detail;
    alert("❌ Failed to save changes: " + (serverMessage || err.message));
  }
};


  const handleStatusChange = async (index, newStatus) => {
    const participant = localEventData.participants[index];

    // Optimistically update UI

    setLocalEventData(prev => {
      const updatedParticipants = [...prev.participants];
      updatedParticipants[index] = {
        ...updatedParticipants[index],
        status: newStatus,
      };
      return { ...prev, participants: updatedParticipants };
    });

    try {

      await participantsPATCH(participant.user_id, {
        event_id: localEventData.id,
        status: newStatus,
      });

    } catch (err) {
      const serverMessage = err.response?.data?.detail;
      alert('❌ Failed to  changes: ' + (serverMessage || err.message));
    }
  };







  return (
    <Container className="p-0">
      <Row className="align-items-center mb-2">
        <Col>
          <h6
            className="text-uppercase mb-0"
            style={{
              fontSize: '30px',
              fontWeight: '700',
              fontStyle: 'bolder',
              color: '#740A03',
              fontFamily: 'Arial, sans-serif', // same font as buttons
           //   color: 'inherit',    // inherit from parent
            }}
          >
            My Events
          </h6>
        </Col>


        <Col xs="auto">
          <Button
            variant="success"
            onClick={() => setShowAddModal(true)}
            style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderColor: '#b84a13',
              backgroundColor: '#b84a13',
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              style={{ fontSize: '1.8rem' }} // increase size to fill button
            />
          </Button>
        </Col>

      </Row>


      {/* Event List */}


      <div className="w-100" style={{ maxHeight: '200px' }}>
        {events.map((event) => (
          <Row
            key={event.id}
            className="align-items-center mb-2 p-2 border rounded"
            style={{ 
              background: '#b84a13',
              borderRadius: '12px',
            }}
          >
            <Col style={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap', 
              color: '#FFFAF0' }} title={event.event_name || '(No Title)'}>
              <strong title={event.event_name || '(No Title)'}>
                {event.event_name || '(No Title)'}
              </strong>
            </Col>
            <Col xs="auto">
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleView(event)}
                style={{
                  borderRadius: '15px',
                  width: '100px',
                  padding: 5,
                }}
              >
                View
              </Button>
            </Col>
          </Row>
        ))}
      </div>




      {/* View Modal */}


      <Modal show={showViewModal} onHide={() => setShowViewModal(false)}
        size="lg"
        backdrop="static"
        keyboard={false}>

        <div
          style={{
          //  backgroundColor: "#ff9500d8", // bright background
      //      color: "#fff",              // white text
          }}
        >

          <Modal.Header closeButton onHide={() => {
            fetchEvents();         // ⬅️ refresh events when modal closes
          }}>
            <Modal.Title>Event Details</Modal.Title>
          </Modal.Header>        <Modal.Body>

            <Row className="mb-3 g-3">
              {/* Event Name */}
              <Col xs={12} md={8} className="d-flex flex-column">
                <label className="form-label-sm mb-1">Event Name</label>
                <input
                  type="text"
                  name="event_name"
                  value={localEventData?.event_name}
                  onChange={handleLocalChange}
                  className="form-control"
                  style={{
                    width: '100%',
                    height: '60px',
                    fontSize: '1.2rem',
                    padding: '0.75rem',
                  }}
                />
              </Col>

              {/* Event Date */}
              <Col xs={12} md={4} className="d-flex flex-column">
                <label className="form-label-sm mb-1">Event Date</label>
                <DatePicker
                  selected={
                    localEventData?.event_date
                      ? new Date(localEventData.event_date)
                      : null
                  }
                  onChange={(date) =>
                    setLocalEventData((prev) => ({
                      ...prev,
                      event_date: date.toISOString().split('T')[0],
                    }))
                  }
                  dateFormat="yyyy-MM-dd"
                  minDate={new Date()}
                  required
                  customInput={
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        width: '100%',
                        height: '60px',
                        fontSize: '1.2rem',
                        padding: '0.75rem',
                      }}
                    />
                  }
                />
              </Col>
            </Row>



            {localEventData && (
              <>

                <Row className="mb-2">
                  <Col xs="auto">
                    <label className="form-label form-label-sm me-1 mb-0">Start Time</label>
                    <input
                      className="form-control form-control-sm"
                      type="time"
                      name="start_time"
                      value={localEventData.start_time}
  onChange={(e) => handleTimeChange('start_time', e.target.value)}
                      style={{ width: '200px' }}
                      onClick={(e) => e.currentTarget.showPicker?.()} // opens picker on click anywhere
                    disabled
                    />
                  </Col>

                  <Col xs="auto">
                    <label className="form-label form-label-sm me-1 mb-0">End Time</label>
                    <input
                      className="form-control form-control-sm"
                      type="time"
                      name="end_time"
                      value={localEventData.end_time}
  onChange={(e) => handleTimeChange('end_time', e.target.value)}
                      style={{ width: '200px' }}
                      onClick={(e) => e.currentTarget.showPicker?.()} // opens picker on click anywhere
                    disabled
                    />
                  </Col>
                </Row>


                <div className="mb-3">
                  <textarea
                    className="form-control form-control-sm"
                    name="description"
                    value={localEventData.description}
                    onChange={handleLocalChange}
                    style={{ height: '150px' }}
                  />
                </div>

                <Row className="mb-3">
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Max Participants</label>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      name="max_participants"
                      value={localEventData.max_participants}
                      onChange={handleLocalChange}
                      style={{ width: '150px' }}
                    />
                  </Col>
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Address</label>
                    <input
                      className="form-control form-control-sm"
                      name="address"
                      value={localEventData.address}
                      onChange={handleLocalChange}
                      style={{ width: '398px' }}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Venue</label>
                    <input
                      className="form-control form-control-sm"
                      name="venue"
                      value={localEventData.venue}
                      onChange={handleLocalChange}
                      style={{ width: '400px' }}
                    />
                  </Col>

                  <Col xs="auto">
                    <label className="form-label form-label-sm mb-0 me-2">Permission</label>
                    <select
                      className="form-select form-select-sm"
                      name="permission"
                      value={localEventData.permission}
                      onChange={handleLocalChange}
                      style={{ width: '200px' }}
                    >
                      <option value="none">None</option>
                      <option value="need_permission">Need Permision</option>
                    </select>
                  </Col>
                </Row>
                <Table size="sm" bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {localEventData.participants?.length > 0 ? (
                      localEventData.participants.map((p, idx) => (
                        <tr key={idx}>
                          <td>{p.full_name}</td>
                          <td>{p.email}</td>
                          <td>
                            <td>



                              {localEventData.event_status === "Close" && p.status !== "approved" ? (
                                <span className="text-danger fw-bold">Event Full</span>
                              ) : (
                                <select
                                  className="form-select form-select-sm"
                                  value={p.status}
                                  onChange={(e) => handleStatusChange(idx, e.target.value)}
                                >
                                  <option value="pending">Pending</option>
                                  <option value="approved">Approved</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              )}


                            </td>







                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-muted">
                          No participants
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setShowDeleteConfirm(true)}>Delete</Button>
            <Button variant="primary" onClick={

              handleSaveChanges



            }>Save Changes</Button>
          </Modal.Footer>
        </div>
      </Modal>


      {/* Add Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg"


      >
        <div
          style={{
         //   backgroundColor: "#ff9500d8", // bright background
       //     color: "#fff",              // white text
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New Event</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <EventForm
              onSuccess={() => {
                fetchEvents();              // ⬅️ Re-fetch the updated list
                setShowAddModal(false);     // ⬅️ Close the modal
              }}
            />

          </Modal.Body>

        </div>
      </Modal>

      <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger mb-0">
            ⚠️ Are you sure you want to permanently delete the event{' '}
            <strong>{localEventData?.event_name}</strong>?
          </p>
        </Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={() =>

            setShowDeleteConfirm(false)

          }>
            Cancel
          </Button>

          <Button variant="danger" onClick={async () => {
            try {
              await eventDELETE({ id: localEventData.id });
              setEvents(prev => prev.filter(ev => ev.id !== localEventData.id));
              setShowDeleteConfirm(false);
              setShowViewModal(false);
              fetchEvents();
            } catch (err) {

              const serverMessage = err.response?.data?.detail || err.message;
              alert(serverMessage);
            }
          }}>
            Yes, Delete
          </Button>
        </Modal.Footer>


      </Modal>



    </Container >
  );
};

export default MyEvents;
